import { render, staticRenderFns } from "./GapList.vue?vue&type=template&id=4d0518e4&scoped=true"
import script from "./GapList.vue?vue&type=script&lang=js"
export * from "./GapList.vue?vue&type=script&lang=js"
import style0 from "./GapList.vue?vue&type=style&index=0&id=4d0518e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0518e4",
  null
  
)

export default component.exports